module.exports = __webpack_public_path__ + "img/logo.d1333778.png";